import React from "react";

const DotsCtaM = () => (
  <svg width="162" height="445" viewBox="0 0 162 445" fill="none" xmlns="http://www.w3.org/2000/svg">
<g style={{mixBlendMode: "difference"}}>
<path className="st0" d="M240.9,4.2c0.1,2.2-1.5,4.1-3.7,4.2l0,0c-2.2,0.1-4.1-1.5-4.2-3.7c-0.1-2.2,1.5-4.1,3.7-4.2l0,0
  C238.9,0.3,240.8,2,240.9,4.2z" fill="#FFFFFF" />
<path className="st0" d="M272.1,4.6c0.2-2.2,2.1-3.8,4.3-3.6l0,0c2.2,0.2,3.8,2.1,3.6,4.3c-0.2,2.2-2.1,3.8-4.3,3.6l0,0
  C273.5,8.7,271.9,6.8,272.1,4.6z" fill="#FFFFFF" />
<path className="st0" d="M202.1,9.1c0.5,2.2-0.9,4.3-3,4.8l0,0c-2.2,0.5-4.3-0.9-4.8-3c-0.5-2.2,0.9-4.3,3-4.8l0,0
  C199.5,5.6,201.6,6.9,202.1,9.1z" fill="#FFFFFF" />
<path className="st0" d="M310.8,10.4c0.5-2.1,2.7-3.5,4.8-2.9l0,0c2.1,0.5,3.5,2.7,2.9,4.8c-0.5,2.1-2.7,3.5-4.8,2.9l0,0
  C311.6,14.7,310.3,12.6,310.8,10.4z" fill="#FFFFFF" />
<path className="st0" d="M164.4,19.9c0.8,2.1-0.2,4.4-2.3,5.2l0,0c-2.1,0.8-4.4-0.2-5.2-2.3c-0.8-2.1,0.2-4.4,2.3-5.2l0,0
  C161.3,16.8,163.6,17.8,164.4,19.9z" fill="#FFFFFF" />
<path className="st0" d="M348.2,22.2c0.9-2,3.2-3,5.2-2.1l0,0c2,0.9,3,3.2,2.1,5.2c-0.9,2-3.2,3-5.2,2.1l0,0
  C348.3,26.6,347.3,24.2,348.2,22.2z" fill="#FFFFFF" />
<path className="st0" d="M128.9,36.3c1.1,1.9,0.5,4.4-1.4,5.5l0,0c-1.9,1.1-4.4,0.5-5.5-1.4c-1.1-1.9-0.5-4.4,1.4-5.5l0,0
  C125.3,33.8,127.8,34.4,128.9,36.3z" fill="#FFFFFF" />
<path className="st0" d="M383.2,39.7c1.2-1.9,3.6-2.4,5.5-1.3l0,0c1.9,1.2,2.4,3.6,1.3,5.5c-1.2,1.9-3.6,2.4-5.5,1.3l0,0
  C382.6,44.1,382,41.6,383.2,39.7z" fill="#FFFFFF" />
<path className="st0" d="M96.4,58.2c1.4,1.7,1.2,4.2-0.5,5.6l0,0c-1.7,1.4-4.2,1.2-5.6-0.5c-1.4-1.7-1.2-4.2,0.5-5.6l0,0
  C92.5,56.2,95,56.5,96.4,58.2z" fill="#FFFFFF" />
<path className="st0" d="M415,62.6c1.5-1.7,4-1.8,5.6-0.4l0,0c1.7,1.5,1.8,4,0.4,5.6c-1.5,1.7-4,1.8-5.6,0.4l0,0l0,0
  C413.7,66.8,413.5,64.3,415,62.6z" fill="#FFFFFF" />
<path className="st0" d="M67.8,85c1.7,1.5,1.8,4,0.4,5.6l0,0l0,0c-1.5,1.7-4,1.8-5.6,0.4c-1.7-1.5-1.8-4-0.4-5.6l0,0
  C63.6,83.7,66.2,83.5,67.8,85z" fill="#FFFFFF" />
<path className="st0" d="M442.7,90.3c1.7-1.4,4.2-1.2,5.6,0.5l0,0c1.4,1.7,1.2,4.2-0.5,5.6s-4.2,1.2-5.6-0.5l0,0
  C440.7,94.2,441,91.7,442.7,90.3z" fill="#FFFFFF" />
<path className="st0" d="M43.9,116c1.9,1.2,2.4,3.6,1.3,5.5l0,0c-1.2,1.9-3.6,2.4-5.5,1.3c-1.9-1.2-2.4-3.6-1.3-5.5l0,0
  C39.5,115.4,42,114.8,43.9,116z" fill="#FFFFFF" />
<path className="st0" d="M465.6,122.1c1.9-1.1,4.4-0.5,5.5,1.4l0,0c1.1,1.9,0.5,4.4-1.4,5.5c-1.9,1.1-4.4,0.5-5.5-1.4l0,0
  C463.1,125.6,463.7,123.2,465.6,122.1z" fill="#FFFFFF" />
<path className="st0" d="M25.2,150.4c2,0.9,3,3.2,2.1,5.2l0,0c-0.9,2-3.2,3-5.2,2.1c-2-0.9-3-3.2-2.1-5.2l0,0
  C20.8,150.5,23.2,149.6,25.2,150.4z" fill="#FFFFFF" />
<path className="st0" d="M483.2,157.1c2.1-0.8,4.4,0.2,5.2,2.3l0,0c0.8,2.1-0.2,4.4-2.3,5.2c-2.1,0.8-4.4-0.2-5.2-2.3l0,0
  C480.1,160.2,481.2,157.9,483.2,157.1z" fill="#FFFFFF" />
<path className="st0" d="M12.2,187.4c2.1,0.5,3.5,2.7,2.9,4.8l0,0c-0.5,2.1-2.7,3.5-4.8,2.9c-2.1-0.5-3.5-2.7-2.9-4.8l0,0
  C7.9,188.1,10.1,186.8,12.2,187.4z" fill="#FFFFFF" />
<path className="st0" d="M495.2,194.4c2.2-0.5,4.3,0.9,4.8,3l0,0c0.5,2.2-0.9,4.3-3,4.8s-4.3-0.9-4.8-3l0,0
  C491.6,197,493,194.8,495.2,194.4z" fill="#FFFFFF" />
<path className="st0" d="M5.2,225.9c2.2,0.2,3.8,2.1,3.6,4.3l0,0c-0.2,2.2-2.1,3.8-4.3,3.6c-2.2-0.2-3.8-2.1-3.6-4.3l0,0
  C1,227.3,3,225.7,5.2,225.9z" fill="#FFFFFF" />
<path className="st0" d="M501.3,233c2.2-0.1,4.1,1.5,4.2,3.7l0,0c0.1,2.2-1.5,4.1-3.7,4.2c-2.2,0.1-4.1-1.5-4.2-3.7l0,0
  C497.4,235.1,499.1,233.2,501.3,233z" fill="#FFFFFF" />
<path className="st0" d="M4.1,265c2.2-0.1,4.1,1.5,4.2,3.7l0,0c0.1,2.2-1.5,4.1-3.7,4.2c-2.2,0.1-4.1-1.5-4.2-3.7l0,0
  C0.2,267.1,1.9,265.2,4.1,265z" fill="#FFFFFF" />
<path className="st0" d="M501.4,272.2c2.2,0.2,3.8,2.1,3.6,4.3l0,0c-0.2,2.2-2.1,3.8-4.3,3.6c-2.2-0.2-3.8-2.1-3.6-4.3l0,0
  C497.3,273.6,499.2,272,501.4,272.2z" fill="#FFFFFF" />
<path className="st0" d="M9,303.9c2.2-0.5,4.3,0.9,4.8,3l0,0c0.5,2.2-0.9,4.3-3,4.8c-2.2,0.5-4.3-0.9-4.8-3l0,0
  C5.5,306.5,6.8,304.4,9,303.9z" fill="#FFFFFF" />
<path className="st0" d="M495.6,310.9c2.1,0.5,3.5,2.7,2.9,4.8l0,0c-0.5,2.1-2.7,3.5-4.8,2.9c-2.1-0.5-3.5-2.7-2.9-4.8l0,0
  C491.2,311.7,493.4,310.4,495.6,310.9z" fill="#FFFFFF" />
<path className="st0" d="M19.7,341.6c2.1-0.8,4.4,0.2,5.2,2.3l0,0c0.8,2.1-0.2,4.4-2.3,5.2c-2.1,0.8-4.4-0.2-5.2-2.3l0,0
  C16.7,344.7,17.7,342.4,19.7,341.6z" fill="#FFFFFF" />
<path className="st0" d="M483.8,348.3c2,0.9,3,3.2,2.1,5.2l0,0c-0.9,2-3.2,3-5.2,2.1c-2-0.9-3-3.2-2.1-5.2l0,0
  C479.4,348.4,481.7,347.4,483.8,348.3z" fill="#FFFFFF" />
<path className="st0" d="M36.2,377.1c1.9-1.1,4.4-0.5,5.5,1.4l0,0c1.1,1.9,0.5,4.4-1.4,5.5c-1.9,1.1-4.4,0.5-5.5-1.4l0,0
  C33.7,380.7,34.3,378.2,36.2,377.1z" fill="#FFFFFF" />
<path className="st0" d="M466.2,383.3c1.9,1.2,2.4,3.6,1.3,5.5l0,0c-1.2,1.9-3.6,2.4-5.5,1.3c-1.9-1.2-2.4-3.6-1.3-5.5l0,0
  C461.9,382.7,464.4,382.1,466.2,383.3z" fill="#FFFFFF" />
<path className="st0" d="M58.1,409.6c1.7-1.4,4.2-1.2,5.6,0.5l0,0c1.4,1.7,1.2,4.2-0.5,5.6c-1.7,1.4-4.2,1.2-5.6-0.5l0,0
  C56.1,413.5,56.4,411,58.1,409.6z" fill="#FFFFFF" />
<path className="st0" d="M443.3,415.1c1.7,1.5,1.8,4,0.4,5.6l0,0c-1.5,1.7-4,1.8-5.6,0.4c-1.7-1.5-1.8-4-0.4-5.6l0,0
  C439.2,413.8,441.7,413.6,443.3,415.1z" fill="#FFFFFF" />
<path className="st0" d="M84.9,438.2c1.5-1.7,4-1.8,5.6-0.4l0,0c1.7,1.5,1.8,4,0.4,5.6c-1.5,1.7-4,1.8-5.6,0.4l0,0
  C83.6,442.4,83.4,439.8,84.9,438.2z" fill="#FFFFFF" />
</g>
</svg>
);

export default DotsCtaM;
